An advertisement branding in a paginated list.
